import IntlMessageFormat from 'intl-messageformat';
export var getMessageFormatter = function (locale, messages, localeMode) {
    return function (id) {
        var matchedMessage = id ? messages[id] : '';
        var message = typeof matchedMessage === 'object' ? matchedMessage.text : matchedMessage;
        if (!message) {
            console.warn("Missing translation for id: ".concat(id));
            return {
                format: function () { return id; },
                formatToParts: function () { return ({ id: id }); },
            };
        }
        var formatter = new IntlMessageFormat(message, locale);
        var messageId = typeof matchedMessage === 'string' ? id : matchedMessage.legacyId;
        return {
            format: function (values) {
                var formatted = formatter.format(values ? values : {});
                if (!localeMode) {
                    return formatted;
                }
                var messageCategoryValue = '';
                var messageIdValue = '';
                switch (localeMode) {
                    case 'asian':
                        return "".concat(formatted, "\u610F");
                    case 'codes':
                        return "[".concat(id, "]").concat(messageId ? "-(".concat(messageId, ")") : '');
                    case 'dev':
                        return "".concat(formatted, "'");
                    case 'empty':
                        return '';
                    case 'ids':
                    case 'prod':
                        return "".concat(id);
                    case 'upper':
                        return formatted.toUpperCase();
                    case 'steganography':
                        if (messageId) {
                            var parts = messageId.split('.');
                            if ((parts === null || parts === void 0 ? void 0 : parts.length) >= 2) {
                                messageCategoryValue = parts[0];
                                messageIdValue = parts.slice(1).join('.');
                            }
                        }
                        return "{{{".concat(locale, "$$$").concat(messageIdValue, "$$$").concat(messageCategoryValue, "}}}").concat(formatted);
                    default:
                        return formatted;
                }
            },
            formatToParts: function () { return ({
                id: id,
                legacyId: messageId,
            }); },
        };
    };
};
